export const BREADCRUMBS_TEST_ID = 'breadcrumbs';
export const MAX_ITEMS = 3;
export const SEPARATOR = '/';
